import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const testimonials = [
    {
        image: require('./../../images/testimonials/komitet.png'),
        reviewername: 'Polski Komitet Olimpijski',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/pzsw.png'),
        reviewername: 'Polski Związek Sportów Wrotkarskich',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/redbull.png'),
        reviewername: 'Red Bull',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },    {
        image: require('./../../images/testimonials/100cznia.png'),
        reviewername: '100cznia',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/babimost.png'),
        reviewername: 'Gmina Babimost',
        position: 'Wojt Gminy',
        review: 'Excellent Customer support!. The template itself is very ext ended. simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/minsk_mazowiecki.png'),
        reviewername: 'Gmina Mińsk Mazowiecki',
        position: 'Wojt Gminy',
        place: 'Mińsk Mazowiecki',
        review: 'The template itself is very ext ended. excellent customer support! simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/olsztyn.png'),
        reviewername: 'Gmina Olsztyn',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support! simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/radymno.png'),
        reviewername: 'Gmina Radymno',
        position: 'Wojt Gminy',
        review: 'Excellent Customer support!. The template itself is very ext ended. simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/jaroslaw.png'),
        reviewername: 'Gmina Jarosław',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/jedlicze.png'),
        reviewername: 'Gmina Jedlicze',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/celestynow.png'),
        reviewername: 'Gmina Celestynów',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/gdansk.png'),
        reviewername: 'Miasto Gdańsk',
        position: 'Prezydent Miasta',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
    {
        image: require('./../../images/testimonials/lebork.png'),
        reviewername: 'Gmina Lębork',
        position: 'Wojt Gminy',
        review: 'The template itself is very ext ended. excellent customer support!.  simply dummy text of the printing and industry. the printing and typesetting industry. Lorem Ipsum has been the industry\'s'
    },
]

var bnr1 = require('./../../images/background/bg6.jpg');

class Testimonials extends React.Component {
    render() {

        const options = {
            loop:true,
            autoplay:true,
            autoplayTimeout: 2000,
            smartSpeed: 3000,
            slideBy: 1,
            margin:30,
            nav:false,
            dots: true,
            rewind: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive:{
                0:{
                    items:1
                },
                991:{
                    items:3
                }
            }
        };
        
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b50 square_shape2 bg-cover" style={{backgroundImage:"url(" + bnr1 + ", )", borderBottom: "1px solid #337ab7"}}>
                    <div className="container">
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Zadowoleni</span> Klienci</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* TESTIMONIAL START */}
                            <OwlCarousel className="owl-carousel testimonial-home" {...options}>
                            
                                {testimonials.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="testimonial-2 m-a30 hover-animation-1">
                                            <div className=" block-shadow bg-white p-a30 ">
                                                <div className="testimonial-detail clearfix " style={{textAlign: 'center'}}>
                                                    <div className="testimonial-pic  scale-in-center" style={{margin: '0 auto'}}><img  src={item.image} alt=""/></div>
                                                    <h4 className="testimonial-name " style={{paddingTop: '10px'}}>{item.reviewername} </h4>
                                                    {/* <span className="testimonial-position">{item.position}</span> */}
                                                </div>
                                                <div className="testimonial-text">
                                                    {/* <span className="fa fa-quote-right" /> */}
                                                    {/* <p> {item.review}</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>    
                               
                            
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l150 text-uppercase ">
                        <strong>Zaufali nam</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default Testimonials;